/**
 * Slider :: slide
 * - - - - - - - - - -
 * @source : https://splidejs.com/guides/getting-started/
 *
 * Ex : slider agence sur single offre
 */
import { who_get_css_device, who_throttle } from "./helpers";


export default class WhoSplideJS {

    constructor(){

        // if splide is defined
        if( typeof Splide !== 'undefined' ){
            this.splideCarousel();
            this.splideSlider();
            this.splideSliderMobile();
        }
    }


    splideCarousel(){

        var elms = document.getElementsByClassName( 'splide--carousel' );

        if( elms ){

            for ( var i = 0; i < elms.length; i++ ) {

                /*
                console.log( elms[ i ] ) ;
                new Splide( elms[ i ] ).mount();
                */

                var splide = new Splide( elms[ i ] );
                var bar    = splide.root.querySelector( '.splide-slide-list__progress-bar' );

                // Updates the bar width whenever the carousel moves:
                splide.on( 'mounted move', function () {

                    var end  = splide.Components.Controller.getEnd() + 1;
                    var rate = Math.min( ( splide.index + 1 ) / end, 1 );
                    bar.style.width = String( 100 * rate ) + '%';
                } );

                splide.mount();
            }
        }
    }


    splideSlider(){

        var elms = document.getElementsByClassName( 'splide--slider' );

        if( elms ){

            for ( var i = 0; i < elms.length; i++ ) {

                var splide = new Splide( elms[ i ] );

                splide.mount();
            }
        }
    }


    splideSliderMobile(){

        var elms = document.getElementsByClassName( 'splide--slider-mobile' );

        if( elms ){

            for ( var i = 0; i < elms.length; i++ ) {

                var splide = new Splide( elms[ i ] );

                var bar    = splide.root.querySelector( '.splide-slide-list__progress-bar' );

                // Updates the bar width whenever the carousel moves:
                splide.on( 'mounted move', function () {

                    var end  = splide.Components.Controller.getEnd() + 1;
                    var rate = Math.min( ( splide.index + 1 ) / end, 1 );
                    bar.style.width = String( 100 * rate ) + '%';
                } );

                const splideMobile = this.splide_mobile_update( splide );

                window.addEventListener('resize', () =>{
                    const the_update = who_throttle( splideMobile, 250 );
                });

                this.splide_mobile_update( splide );

            }
        }
    }


    splide_mobile_update( slider ){

        if( 'mobile' === who_get_css_device() ){

            // https://splidejs.com/guides/apis/#states
            if( ! slider.state.is( Splide.STATES.IDLE ) ){
                slider.mount() ;
            }
        }else{
            slider.destroy();
        }

    }

}


